import { TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { html } from 'lit/static-html.js';

/**
 * The Facets component.
 * @element sic-facets
 * @slot defaultSlot
 *
 * Lightdom styles in sic-facets.lightdom.css included in /shared.css
 */
@customElement('sic-facets')
export class SicFacets extends OutlineElement {
  firstUpdated(): void {}

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-facets': SicFacets;
  }
}
